// extracted by mini-css-extract-plugin
export default {"FAQ_section":"YourFaqs_FAQ_section__0YuEX","addLink":"YourFaqs_addLink__SXCLs","conversationText":"YourFaqs_conversationText__dOqZ-","inputTextare":"YourFaqs_inputTextare__7IpHg"};